import { Outlet, Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Calendar, LogOut, Plus } from 'lucide-react';

export function Layout() {
    const { user, logout } = useAuth();
    const location = useLocation();

    return (
        <div className="min-h-screen">
            <header className="header">
                <div className="container header-content">
                    <Link to="/dashboard" className="header-logo">
                        <Calendar style={{ display: 'inline', marginRight: '8px' }} />
                        AAM <span>Let's Meet</span>
                    </Link>

                    <nav className="header-nav">
                        <Link
                            to="/dashboard"
                            style={{
                                opacity: location.pathname === '/dashboard' ? 1 : 0.8
                            }}
                        >
                            Dashboard
                        </Link>
                        <Link
                            to="/events/new"
                            style={{ opacity: location.pathname === '/events/new' ? 1 : 0.8 }}
                        >
                            <Plus size={16} style={{ display: 'inline', marginRight: '4px' }} />
                            New Event
                        </Link>
                    </nav>

                    <div className="header-user">
                        <span style={{ opacity: 0.8, fontSize: '0.875rem' }}>
                            {user?.name || user?.email}
                        </span>
                        <button
                            onClick={logout}
                            className="btn btn-ghost"
                            style={{ color: 'white', padding: '8px' }}
                            title="Sign out"
                        >
                            <LogOut size={18} />
                        </button>
                    </div>
                </div>
            </header>

            <main>
                <Outlet />
            </main>
        </div>
    );
}
